import { render, staticRenderFns } from "./PercentageBadge.vue?vue&type=template&id=efc33d58&scoped=true&"
import script from "./PercentageBadge.vue?vue&type=script&lang=js&"
export * from "./PercentageBadge.vue?vue&type=script&lang=js&"
import style0 from "./PercentageBadge.vue?vue&type=style&index=0&id=efc33d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc33d58",
  null
  
)

export default component.exports